/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * Statute page.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statute-page',
  templateUrl: './statute-page.component.html',
  styleUrls: ['./statute-page.component.scss']
})
export class StatutePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
